<!-- A time of day as hh:mm, 24-hour, in every browser (see ./dates.js for why
     not the browser's own time field, which an English browser draws as
     10:00 AM). Typed: 9, 930, 9.30 and 9:30 all read as 09:30.

     The value is 'HH:mm' both ways. Something typed that does not read goes
     back to the last good one on blur. Every attribute passes through to the
     Vuetify text field. -->
<template>
  <v-text-field
    :model-value="draft"
    :disabled="disabled"
    placeholder="tt:mm"
    inputmode="numeric"
    autocomplete="off"
    v-bind="$attrs"
    @update:model-value="draft = $event || ''"
    @blur="commit"
    @keydown.enter.prevent="commit"
  />
</template>

<script>
import { parseTime } from './dates'

export default {
  inheritAttrs: false,
  props: {
    modelValue: { type: String, default: '' },
    disabled: { type: Boolean, default: undefined }
  },
  emits: ['update:modelValue'],
  data () {
    return { draft: this.modelValue || '' }
  },
  watch: {
    modelValue (value) {
      this.draft = value || ''
    }
  },
  methods: {
    commit () {
      const value = parseTime(this.draft)
      if (value && value !== this.modelValue) this.$emit('update:modelValue', value)
      this.draft = value || this.modelValue || ''
    }
  }
}
</script>
